import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {User} from '../../core/_models'
import {IPersonProfile} from "../../../interfaces/IPersonProfile";
import { IVerification } from '../../../interfaces/IVerification';

type Props = {
  column: ColumnInstance<IVerification>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
